import { render, staticRenderFns } from "./ProjectTable.vue?vue&type=template&id=9c737066&scoped=true"
import script from "./ProjectTable.vue?vue&type=script&lang=ts"
export * from "./ProjectTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c737066",
  null
  
)

export default component.exports